import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import ProdRcpt01Actions, { ProdRcpt01Types } from '../Stores/ProdRcpt01/Actions';

const getAppStore = state => state.app;

export function* prodRcpt01FetchProdRcpt01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(ProdRcpt01Actions.prodRcpt01FetchProdRcpt01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `prodRcpt/indexProcess/PROD_RCPT/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        ProdRcpt01Actions.prodRcpt01FetchProdRcpt01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ProdRcpt01Actions.prodRcpt01FetchProdRcpt01Loading(false));
  }
}

export function* prodRcpt01CreateProdRcpt01({ hdrIds }) {
  try {
    yield put(ProdRcpt01Actions.prodRcpt01CreateProdRcpt01Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `prodRcpt/createProcess/PROD_RCPT`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(ProdRcpt01Actions.prodRcpt01CreateProdRcpt01Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ProdRcpt01Actions.prodRcpt01CreateProdRcpt01Loading(false));
  }
}

export function* prodRcpt01GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/prodSheetDetail/update/${hdrId}`));
}

export function* prodRcpt01NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/prodSheetDetail/create/${app.curDivisionId}`));
}

export const saga = [
  takeLatest(ProdRcpt01Types.PROD_RCPT01_FETCH_PROD_RCPT01, prodRcpt01FetchProdRcpt01),
  takeLatest(ProdRcpt01Types.PROD_RCPT01_CREATE_PROD_RCPT01, prodRcpt01CreateProdRcpt01),
  takeLatest(ProdRcpt01Types.PROD_RCPT01_GO_TO_DOCUMENT, prodRcpt01GoToDocument),
  takeLatest(ProdRcpt01Types.PROD_RCPT01_NEW_DOCUMENT, prodRcpt01NewDocument)
];
